import { t } from "../../i18n";
import { CheckCircle2 } from "lucide-react";
import { asRecord, stringValue } from "./ToolResultView.utils";
import { MetaItem } from "../MetaItem";
import { CopyButton } from "../CopyButton";

export function MessageResult({
  name,
  result,
  argumentsValue,
}: {
  name: string;
  result: unknown;
  argumentsValue?: unknown;
}) {
  const values = asRecord(result);
  const input = asRecord(argumentsValue);
  const isEmail = name === "send_email_notification";
  const suppressed = values?.suppressed === true;
  const sent = values?.sent === true;
  const recipients = Array.isArray(values?.to)
    ? values.to.join(", ")
    : stringValue(values?.to) ||
      (Array.isArray(input?.to) ? input.to.join(", ") : stringValue(input?.to));
  const message = stringValue(input?.message);
  const subject = stringValue(values?.subject) || stringValue(input?.subject);
  return (
    <div
      className={`rounded-2xl border p-3 ${suppressed ? "border-amber-200 bg-amber-50/70 dark:border-amber-900/60 dark:bg-amber-950/20" : "border-emerald-200 bg-emerald-50/70 dark:border-emerald-900/60 dark:bg-emerald-950/20"}`}
    >
      <div
        className={`flex items-center gap-2 text-sm font-semibold ${suppressed ? "text-amber-800 dark:text-amber-200" : "text-emerald-800 dark:text-emerald-200"}`}
      >
        <CheckCircle2 size={16} />
        {suppressed
          ? isEmail
            ? "Email not sent"
            : "WhatsApp message not sent"
          : sent
            ? isEmail
              ? "Email sent"
              : "WhatsApp message sent"
            : isEmail
              ? "Email result"
              : "WhatsApp result"}
      </div>
      {suppressed && (
        <p className="mt-1 text-xs leading-5 text-amber-800 dark:text-amber-200">
          {t("The recipient is unsubscribed from email notifications.")}
        </p>
      )}
      <div className="mt-3 grid gap-2 sm:grid-cols-2">
        <MetaItem
          label={isEmail ? "Recipient" : "To"}
          value={recipients || "—"}
        />
        {isEmail && <MetaItem label={t("Subject")} value={subject || "—"} />}
        {stringValue(values?.messageId) && (
          <MetaItem
            label={t("Message ID")}
            value={stringValue(values?.messageId)}
          />
        )}
      </div>
      {message && (
        <div className="mt-3 rounded-xl border border-white/70 bg-white/70 p-3 dark:border-white/10 dark:bg-black/10">
          <div className="flex items-center justify-between gap-2">
            <div className="text-[10px] font-semibold tracking-wide text-stone-400 uppercase">
              {t("Message")}
            </div>
            <CopyButton value={message} />
          </div>
          <p className="mt-1 text-sm leading-6 whitespace-pre-wrap text-stone-700 dark:text-stone-200">
            {message}
          </p>
        </div>
      )}
    </div>
  );
}
